import * as React from 'react';
import autobind from 'autobind-decorator';

import { AutocompleteListDataService } from 'src/core/ui/autocomplete/autocomplete.data';
import { CardController } from 'src/app/shared/card.controller';
import { ClientCommonPartView } from './clientcommon-part.view';

interface ClientCommonPartControllerProps extends ComponentViewProps<ClientItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
}

export class ClientCommonPartController extends React.Component<ClientCommonPartControllerProps, any> {
	protected tagsDataService: AutocompleteListDataService;

	constructor(props) {
		super(props);
		this.tagsDataService = AutocompleteListDataService.make();
	}

	@autobind
	private tagsQuery(q?: string) {
		return new Promise<QueryResult<AutocompleteSummary>>((resolve, reject) => {
			this.tagsDataService.addFilter('concept', 'eq', 'client');
			this.tagsDataService.addFilter('key', 'eq', 'tags');
			this.tagsDataService.addSorting('value', 'asc', true);
			this.tagsDataService.searchKeywords = q;
			this.tagsDataService.pageSize = 100;
			return this.tagsDataService
				.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({ items: items, totalCount: this.tagsDataService.totalPages });
				})
				.catch((error) => {
					this.props.setBusy(false);
					reject(error);
				});
		});
	}

	render() {
		if (this.props.model == null) {
			return null;
		}
		
		const model = this.props.model;
		return (
			<CardController
				icon="book"
				className="card-borderless"
				title="Common information"
				mode={this.props.mode}>
				<ClientCommonPartView
					mode={this.props.mode}
					model={model}
					setBusy={this.props.setBusy}
					tagsQuery={{ query: this.tagsQuery, dataSet: this.tagsDataService }}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/parts/clientcommon-part.controller.tsx